// extracted by mini-css-extract-plugin
export default {"popover":"BooleanInputPopover_popover__tFS5E","buttons":"BooleanInputPopover_buttons__tA+-A","danger":"BooleanInputPopover_danger__wc2Gm"};